export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100/60">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto bg-background-50 rounded-xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-6 md:p-10 lg:p-12">
              <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">飞飞漫画网 APP</h2>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-5 max-w-md">
                下载飞飞漫画网移动客户端，享受更流畅的漫画全集在线看体验。离线下载、夜间模式、推送提醒，随时随地畅读漫画。
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <button
                  type="button"
                  className="flex items-center justify-center gap-2 px-5 py-3 bg-foreground-950 hover:bg-foreground-800 text-background-50 font-medium text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-apple-fill text-lg"></i>
                  <span>App Store 下载</span>
                </button>
                <button
                  type="button"
                  className="flex items-center justify-center gap-2 px-5 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-md transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-android-line text-lg"></i>
                  <span>Android 下载</span>
                </button>
              </div>
              <div className="flex items-center gap-4 mt-5">
                <div className="flex items-center gap-1.5">
                  <i className="ri-star-fill text-xs text-accent-500"></i>
                  <span className="text-xs text-foreground-500">4.9分</span>
                </div>
                <span className="w-1 h-1 rounded-full bg-background-300"></span>
                <span className="text-xs text-foreground-500">500万+安装</span>
                <span className="w-1 h-1 rounded-full bg-background-300"></span>
                <span className="text-xs text-foreground-500">安全纯净</span>
              </div>
            </div>
            <div className="flex-shrink-0 p-6 md:p-10 lg:p-12 flex items-center justify-center">
              <div className="w-40 h-56 md:w-48 md:h-64 bg-gradient-to-br from-primary-200 via-accent-100 to-background-50 rounded-2xl flex items-center justify-center">
                <div className="w-32 h-48 md:w-36 md:h-52 bg-background-50 rounded-lg flex flex-col items-center justify-center gap-2">
                  <div className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-lg">
                    <i className="ri-book-open-line text-lg text-background-50"></i>
                  </div>
                  <span className="font-heading font-bold text-xs text-foreground-950">飞飞漫画</span>
                  <span className="text-[10px] text-foreground-400">漫画大全</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}